export default __webpack_public_path__ + "b73cc3e99f948403368e0bae08366975.woff2";